
import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { DropdownData } from "@/models/DropdownData";

@Component({
  components: {},
})
export default class FilterDropdown<T> extends Vue {
  $refs!: {
    filterBtn: HTMLElement;
    selectorList: HTMLElement;
  };

  @Prop()
  public placeholder!: string;

  @Prop()
  public selectedValue!: DropdownData<T>;

  @Prop()
  public choices!: DropdownData<T>[];

  @Prop({ default: "" })
  public choiceHeader!: string;

  @Prop()
  public focused!: boolean;

  @Prop({ default: true })
  public selectable!: boolean;

  @Prop({ default: "large" })
  public buttonSize!: string;

  isOpen: boolean;

  constructor() {
    super();
    this.isOpen = false;
  }

  get value(): string {
    return this.selectedValue ? this.selectedValue.value : "";
  }

  get componentClasses(): string {
    let classes = [];
    if (this.focused) {
      classes.push("is-focused");
    }
    if (this.isOpen) {
      classes.push("is-open");
    }

    if (this.selectable && this.selectedValue) {
      classes.push("has-value");
    }
    if (!this.selectable) {
      classes.push("disabled");
    }

    classes.push(this.buttonSize);

    return classes.join(" ");
  }

  get selectedLabel(): string {
    return this.selectedValue ? this.selectedValue.title : this.placeholder;
  }

  getChoiceClasses(choice: DropdownData<T>): string {
    let classes = [];

    if (this.selectable && choice.value === this.value) {
      classes.push("is-selected");
    }

    return classes.join(" ");
  }

  open(): void {
    if (!this.isOpen && this.selectable) {
      this.isOpen = true;
    } else {
      this.close();
    }
  }

  close(): void {
    this.isOpen = false;
  }

  selectValue(choice: DropdownData<T>): void {
    this.$emit("click", choice);

    if (choice.value !== this.value) {
      this.$emit("change", choice);
    }
    this.close();
  }

  onClickOutside(event: Event): void {
    this.close();
  }
}
